import api from './axios';
// קבלת כרטיס מוסווה לפי מזהה תרומה
export const get_masked_card = async (donationId) => {
  try {
    const res = await api.get(`/donations/${donationId}/masked-card`);
    return res.data.card;
  } catch (e) {
    return null;
  }
};



// הוספת תרומה
export const add_donation = async (donor_id, donationData) => {
  try {
    if (!donor_id) {
      throw new Error("חסר מזהה תורם");
    }

    const payload = { donor_id, ...donationData };
    const response = await api.post("/donations", payload);

    return response.data;
  } catch (err) {
    throw err;
  }
};

// קבלת כל התרומות
export const get_all_donations = async () => {
  try {
    const response = await api.get("/donations");
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const get_donations_by_donor_id = async (donor_id) => {
  try {
    if (!donor_id) {
      throw new Error("חסר מזהה תורם");
    }

    const response = await api.get(`/donations/by_donor/${donor_id}`);
    return response.data;

  } catch (err) {
    throw err;
  }
};
// מחיקת תרומה
export const delete_donation_by_id = async (id) => {
  try {
    if (!id) {
      throw new Error("חסר מזהה תרומה");
    }

    const response = await api.delete(`/donations/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

// עדכון תרומה
export const update_donation_by_id = async (id, donationData) => {
  try {
    if (!id) {
      throw new Error("חסר מזהה תרומה");
    }

    const response = await api.put(`/donations/${id}`, donationData);
    return response.data;
  } catch (err) {
    throw err;
  }
};

// קבלת תרומה לפי מזהה
export const get_donation_by_id = async (id) => {
  try {
    if (!id) {
      throw new Error("חסר מזהה תרומה");
    }

    const response = await api.get(`/donations/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

// export const get_exchange_rates = async () => {
//   try {
//     const response = await api.get('/exchange-rates');
//     if (response.status !== 200) {
//       throw new Error("שגיאה בטעינת שערי המטבעות");
//     }
//     return response.data;
//   } catch (err) {
//     console.error("שגיאה בטעינת שערי המטבעות:", err);
//     throw err;
//   }
// };